module.exports = __webpack_public_path__ + "static/media/portalresul2.e60984e6.png";